const API_URL = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
const DEV_IMPERSONATION_USER_ID = (process.env.REACT_APP_DEV_IMPERSONATION_USER_ID || '').trim();
let unauthorizedHandler = null;
function buildApiUrl(path) {
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;
    return API_URL ? `${API_URL}${normalizedPath}` : normalizedPath;
}
function buildHeaders(options) {
    const headers = new Headers(options?.headers);
    const hasBody = options?.body !== undefined && options.body !== null;
    const isFormData = typeof FormData !== 'undefined' && options?.body instanceof FormData;
    if (hasBody && !isFormData && !headers.has('Content-Type')) {
        headers.set('Content-Type', 'application/json');
    }
    if (DEV_IMPERSONATION_USER_ID) {
        headers.set('x-user-id', DEV_IMPERSONATION_USER_ID);
    }
    return headers;
}
async function parseErrorMessage(response) {
    const fallback = response.statusText || 'Request failed';
    try {
        const payload = (await response.json());
        return payload.message || payload.error || fallback;
    }
    catch {
        return fallback;
    }
}
export class ApiError extends Error {
    constructor(status, message) {
        super(message);
        Object.defineProperty(this, "status", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: status
        });
        this.name = 'ApiError';
    }
}
export function setApiUnauthorizedHandler(handler) {
    unauthorizedHandler = handler;
}
export async function apiFetch(path, options) {
    const { skipAuthRedirect = false, ...requestInit } = options ?? {};
    const response = await fetch(buildApiUrl(path), {
        ...requestInit,
        credentials: 'include',
        headers: buildHeaders(requestInit),
    });
    if (!response.ok) {
        if (response.status === 401 && !skipAuthRedirect) {
            unauthorizedHandler?.();
        }
        throw new ApiError(response.status, await parseErrorMessage(response));
    }
    if (response.status === 204 || response.headers.get('content-length') === '0') {
        return undefined;
    }
    return response.json();
}
export async function apiFetchBlob(path, options) {
    const { skipAuthRedirect = false, ...requestInit } = options ?? {};
    const response = await fetch(buildApiUrl(path), {
        ...requestInit,
        credentials: 'include',
        headers: buildHeaders(requestInit),
    });
    if (!response.ok) {
        if (response.status === 401 && !skipAuthRedirect) {
            unauthorizedHandler?.();
        }
        throw new ApiError(response.status, await parseErrorMessage(response));
    }
    return response.blob();
}
export function apiUrl(path) {
    return buildApiUrl(path);
}
